module.exports = __webpack_public_path__ + "img/04logo-wss2021.13d6d11f.png";